var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            { attrs: { justify: "start", "no-gutters": "" } },
            [
              _c("v-icon", { staticClass: "pr-2", attrs: { large: "" } }, [
                _vm._v("mdi-calendar-clock"),
              ]),
              _c("h3", [_vm._v(_vm._s(_vm.$t("timeModels")))]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            {
              staticClass: "mt-10 mb-4",
              attrs: { justify: "center", "no-gutters": "" },
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1 table-header",
                    attrs: {
                      headers: _vm.dailyModelListHeaders,
                      items: _vm.filteredDailyModelList,
                      "items-per-page": 3,
                      "item-key": "id",
                      "hide-default-footer": "",
                      page: _vm.dailyPage,
                    },
                    on: {
                      "page-count": function ($event) {
                        _vm.dailyPageCount = $event
                      },
                      "update:page": function ($event) {
                        _vm.dailyPage = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header.dailyModelName",
                        fn: function ({ header }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "caption font-weight-bold" },
                                  [_vm._v(_vm._s(header.text))]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    "prepend-inner-icon": "mdi-magnify",
                                    clearable: "",
                                    "hide-details": "",
                                    dense: "",
                                    solo: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    mousedown: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                  model: {
                                    value: _vm.dailyNameFilter,
                                    callback: function ($$v) {
                                      _vm.dailyNameFilter = $$v
                                    },
                                    expression: "dailyNameFilter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "header.dailyModelText",
                        fn: function ({ header }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "caption font-weight-bold" },
                                  [_vm._v(_vm._s(header.text))]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    "prepend-inner-icon": "mdi-magnify",
                                    clearable: "",
                                    "hide-details": "",
                                    dense: "",
                                    solo: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    mousedown: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                  model: {
                                    value: _vm.dailyRemarkFilter,
                                    callback: function ($$v) {
                                      _vm.dailyRemarkFilter = $$v
                                    },
                                    expression: "dailyRemarkFilter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "", color: "primary" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "mr-2 primary--text",
                                                style: { cursor: "pointer" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getDailyModel(
                                                      item.id
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-pencil ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", { staticClass: "px-1" }, [
                                  _vm._v(_vm._s(_vm.$t("edit"))),
                                ]),
                              ]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "", color: "primary" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "primary--text",
                                                style: { cursor: "pointer" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteDailyModel(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-delete ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", { staticClass: "px-1" }, [
                                  _vm._v(_vm._s(_vm.$t("delete"))),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.dailyModelListSelected,
                      callback: function ($$v) {
                        _vm.dailyModelListSelected = $$v
                      },
                      expression: "dailyModelListSelected",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "text-center pt-2" },
                    [
                      _c("v-pagination", {
                        attrs: { length: _vm.dailyPageCount },
                        model: {
                          value: _vm.dailyPage,
                          callback: function ($$v) {
                            _vm.dailyPage = $$v
                          },
                          expression: "dailyPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "mb-2",
              attrs: { justify: "end", "no-gutters": "" },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { rounded: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.ShowDailyDialog = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("addDailyModel")))]
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "mt-10 mb-4",
              attrs: { justify: "end", "no-gutters": "" },
            },
            [
              _c("v-switch", {
                staticClass: "mt-2",
                attrs: {
                  label: !_vm.showInactiveWeekModels
                    ? _vm.$t("showInactiveWeekModels")
                    : _vm.$t("hideInactiveWeekModels"),
                  "hide-details": "",
                },
                model: {
                  value: _vm.showInactiveWeekModels,
                  callback: function ($$v) {
                    _vm.showInactiveWeekModels = $$v
                  },
                  expression: "showInactiveWeekModels",
                },
              }),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1 table-header",
                    attrs: {
                      headers: _vm.weekModelListHeaders,
                      items: _vm.filteredWeekModelsForTable,
                      "item-key": "id",
                      "items-per-page": 3,
                      "hide-default-footer": "",
                      page: _vm.weekPage,
                      "item-class": _vm.setBackgroundColor,
                    },
                    on: {
                      "page-count": function ($event) {
                        _vm.weekPageCount = $event
                      },
                      "update:page": function ($event) {
                        _vm.weekPage = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header.weekModelName",
                        fn: function ({ header }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "caption font-weight-bold" },
                                  [_vm._v(_vm._s(header.text))]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    "prepend-inner-icon": "mdi-magnify",
                                    clearable: "",
                                    "hide-details": "",
                                    dense: "",
                                    solo: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    mousedown: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                  model: {
                                    value: _vm.weekNameFilter,
                                    callback: function ($$v) {
                                      _vm.weekNameFilter = $$v
                                    },
                                    expression: "weekNameFilter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "header.weekModelText",
                        fn: function ({ header }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "caption font-weight-bold" },
                                  [_vm._v(_vm._s(header.text))]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    "prepend-inner-icon": "mdi-magnify",
                                    clearable: "",
                                    "hide-details": "",
                                    dense: "",
                                    solo: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    mousedown: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                  model: {
                                    value: _vm.weekRemarkFilter,
                                    callback: function ($$v) {
                                      _vm.weekRemarkFilter = $$v
                                    },
                                    expression: "weekRemarkFilter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "", color: "primary" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "mr-2 primary--text",
                                                style: { cursor: "pointer" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getWeekModel(
                                                      item.id
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-pencil ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", { staticClass: "px-1" }, [
                                  _vm._v(_vm._s(_vm.$t("edit"))),
                                ]),
                              ]
                            ),
                            item.inUse
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", color: "primary" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "primary--text",
                                                    style: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteWeekModel(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [_vm._v(" mdi-delete ")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("span", { staticClass: "px-1" }, [
                                      _vm._v(_vm._s(_vm.$t("delete"))),
                                    ]),
                                  ]
                                )
                              : !item.inUse && !item.active
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", color: "primary" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "primary--text",
                                                    style: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.activateWeekModel(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    " mdi-file-document-check "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("span", { staticClass: "px-1" }, [
                                      _vm._v(_vm._s(_vm.$t("activate"))),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", color: "primary" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "primary--text",
                                                    style: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deactivateWeekModel(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    " mdi-file-document-remove "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("span", { staticClass: "px-1" }, [
                                      _vm._v(_vm._s(_vm.$t("deactivate"))),
                                    ]),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.weekModelListSelected,
                      callback: function ($$v) {
                        _vm.weekModelListSelected = $$v
                      },
                      expression: "weekModelListSelected",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "text-center pt-2" },
                    [
                      _c("v-pagination", {
                        attrs: { length: _vm.weekPageCount },
                        model: {
                          value: _vm.weekPage,
                          callback: function ($$v) {
                            _vm.weekPage = $$v
                          },
                          expression: "weekPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "mb-2",
              attrs: { justify: "end", "no-gutters": "" },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { rounded: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.ShowWeeklyDialog = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("addWeeklyModel")))]
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "mt-10 mb-4",
              attrs: { justify: "center", "no-gutters": "" },
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1 table-header",
                    attrs: {
                      headers: _vm.autoWeekModelsHeaders,
                      items: _vm.filteredAutoWeekModels,
                      "item-key": "id",
                      "items-per-page": 3,
                      "hide-default-footer": "",
                      page: _vm.autoModelPage,
                    },
                    on: {
                      "page-count": function ($event) {
                        _vm.autoModelPageCount = $event
                      },
                      "update:page": function ($event) {
                        _vm.autoModelPage = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header.name",
                        fn: function ({ header }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "caption font-weight-bold" },
                                  [_vm._v(_vm._s(header.text))]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    "prepend-inner-icon": "mdi-magnify",
                                    clearable: "",
                                    "hide-details": "",
                                    dense: "",
                                    solo: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    mousedown: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                  model: {
                                    value: _vm.autoNameFilter,
                                    callback: function ($$v) {
                                      _vm.autoNameFilter = $$v
                                    },
                                    expression: "autoNameFilter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "header.commit",
                        fn: function ({ header }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "caption font-weight-bold" },
                                  [_vm._v(_vm._s(header.text))]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    "prepend-inner-icon": "mdi-magnify",
                                    clearable: "",
                                    "hide-details": "",
                                    dense: "",
                                    solo: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    mousedown: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                  model: {
                                    value: _vm.autoRemarkFilter,
                                    callback: function ($$v) {
                                      _vm.autoRemarkFilter = $$v
                                    },
                                    expression: "autoRemarkFilter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "", color: "primary" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "mr-2 primary--text",
                                                style: { cursor: "pointer" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getAutoWeekModel(
                                                      item.id
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-pencil ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", { staticClass: "px-1" }, [
                                  _vm._v(_vm._s(_vm.$t("edit"))),
                                ]),
                              ]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "", color: "primary" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          !item.locked
                                            ? _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "primary--text",
                                                    style: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteAutoWeekModel(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [_vm._v(" mdi-delete ")]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", { staticClass: "px-1" }, [
                                  _vm._v(_vm._s(_vm.$t("delete"))),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "div",
                    { staticClass: "text-center pt-2" },
                    [
                      _c("v-pagination", {
                        attrs: { length: _vm.autoModelPageCount },
                        model: {
                          value: _vm.autoModelPage,
                          callback: function ($$v) {
                            _vm.autoModelPage = $$v
                          },
                          expression: "autoModelPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "mb-2",
              attrs: { justify: "end", "no-gutters": "" },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { rounded: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showAutoWeekModel = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("addAutoWeekModel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-card-actions"),
      _vm.ShowDailyDialog
        ? _c("DailyDialog", {
            attrs: { dailyModelId: _vm.dailyModelId },
            on: {
              close: function ($event) {
                _vm.dailyModelId = 0
                _vm.ShowDailyDialog = false
                _vm.refreshModels()
              },
            },
          })
        : _vm._e(),
      _vm.ShowWeeklyDialog
        ? _c("WeeklyDialog", {
            attrs: {
              weekDailyModelList: _vm.weekDailyModelList,
              weekModelId: _vm.weekModelId,
              dailyModelList: _vm.dailyModelList,
            },
            on: {
              close: function ($event) {
                _vm.weekModelId = 0
                _vm.ShowWeeklyDialog = false

                _vm.refreshModels()
              },
            },
          })
        : _vm._e(),
      _vm.showAutoWeekModel
        ? _c("AutoWeekModel", {
            attrs: {
              WeekModel: _vm.weekAutoModel,
              saveMode: _vm.weekAutoModel.id != null ? true : false,
            },
            on: {
              close: function ($event) {
                _vm.showAutoWeekModel = false
                _vm.refreshModels()
                _vm.setBackAutoWeekModel()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }